'use client'

import React, { useMemo, useState } from 'react'

import { cn } from '@/utilities/ui'

type Props = {
  tags: string[]
  /** Cartões já renderizados no servidor, com as tags de cada um. */
  itens: { tags: string[]; node: React.ReactNode }[]
  rotuloTodos?: string
}

/** Filtros por tag em pílulas + grade de cartões (filtragem no cliente, sem nova consulta). */
export function FiltrosCases({ tags, itens, rotuloTodos = 'Todos' }: Props) {
  const [ativa, setAtiva] = useState<string | null>(null)
  const visiveis = useMemo(
    () => (ativa ? itens.filter((i) => i.tags.includes(ativa)) : itens),
    [ativa, itens],
  )
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-wrap gap-2" role="tablist" aria-label="Filtrar cases">
        {[null, ...tags].map((t) => (
          <button
            key={t ?? '__todos'}
            type="button"
            role="tab"
            aria-selected={ativa === t}
            onClick={() => setAtiva(t)}
            className={cn(
              'ag-mono rounded-full border px-4 py-2 text-[11px] leading-none transition-colors lg:text-[12px]',
              ativa === t
                ? 'border-[var(--ag-primary)] bg-[var(--ag-primary)] text-[var(--ag-text-light)]'
                : 'border-[rgb(var(--sec-border-rgb)/0.2)] bg-[var(--sec-bg)] text-[var(--sec-fg)] hover:border-[rgb(var(--sec-border-rgb)/0.5)]',
            )}
          >
            {t ?? rotuloTodos}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">
        {visiveis.map((i, k) => (
          <React.Fragment key={k}>{i.node}</React.Fragment>
        ))}
      </div>
    </div>
  )
}
